// extracted by mini-css-extract-plugin
export default {"buttons":"address-information_buttons__dYMgT","form":"address-information_form__MRMJN"};